import React, { useRef } from 'react';
import { Card } from '@mui/material';

// Spotlight hover effect from reactbits (https://reactbits.dev/components/spotlight-card),
// adapted onto an MUI Card: a radial glow follows the cursor and fades in on
// hover. Pure CSS + a mousemove handler (no motion dependency). Default glow is
// a subtle brand-blue tuned for the light theme.
export const SpotlightCard = ({
  children,
  spotlightColor = 'rgba(90, 165, 239, 0.18)',
  sx,
  ...rest
}) => {
  const ref = useRef(null);

  const handleMouseMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--sc-x', `${e.clientX - rect.left}px`);
    el.style.setProperty('--sc-y', `${e.clientY - rect.top}px`);
  };

  return (
    <Card
      ref={ref}
      onMouseMove={handleMouseMove}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        '--sc-x': '50%',
        '--sc-y': '50%',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: 'inherit',
          background: `radial-gradient(circle at var(--sc-x) var(--sc-y), ${spotlightColor}, transparent 70%)`,
          opacity: 0,
          transition: 'opacity 0.5s ease',
          pointerEvents: 'none',
          zIndex: 0,
        },
        '&:hover::before, &:focus-within::before': { opacity: 1 },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Card>
  );
};

export default SpotlightCard;
